<template>
    <div class="absolute inset-0 z-[50] flex items-center justify-center pointer-events-none">
        <div
            @click="$emit('joinClick')"
            class="pointer-events-auto cursor-pointer w-[336px] rounded-2xl overflow-hidden backdrop-blur-xl border border-white/10 shadow-2xl"
        >
            <!-- Header Section with Lock Icon -->
            <div class="relative bg-gradient-to-b from-auditionsBlue/90 to-auditionsBlueHover/90 backdrop-blur-md px-3 py-4 flex flex-col items-center justify-center">
                <div class="w-8 h-8 rounded-full bg-white/15 border border-white/20 flex items-center justify-center mb-4">
                    <font-awesome-icon
                        class="h-4 w-4 text-white"
                        :icon="['fa', 'lock']"
                    />
                </div>

                <p class="text-white text-center text-sm font-semibold tracking-wide uppercase opacity-90">
                    Free Limit Reached
                </p>
            </div>

            <!-- Body Section -->
            <div class="bg-black/80 backdrop-blur-md px-6 py-8 flex flex-col items-center">
                <h3 class="text-white text-center text-xl font-bold mb-2">
                    Unlock Unlimited Access
                </h3>

                <p class="text-white/70 text-center text-sm mb-6 leading-relaxed">
                    Watch exclusive Naughty America<br />videos anytime, anywhere
                </p>

                <button
                    @click.stop="$emit('joinClick')"
                    class="w-full bg-auditionsBlue hover:bg-auditionsBlueHover active:bg-auditionsBlueHover text-white px-6 py-3.5 rounded-xl font-semibold transition-all hover:scale-[1.02] active:scale-[0.98] shadow-lg"
                >
                    Unlock All Videos
                </button>

                <p class="text-white/40 text-xs text-center mt-4">
                    Join thousands of members today
                </p>
            </div>
        </div>
    </div>
</template>

<script setup>

defineEmits(['joinClick'])
</script>
